module.exports = __webpack_public_path__ + "static/media/argos-pg3.b0d71137.jpg";